module.exports = __webpack_public_path__ + "static/img/38.ac6240b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/38.png
// module id = CCWS
// module chunks = 1